"use client";

import { Info } from "lucide-react";
import type { FilterSuggestion } from "./filterSuggestions";
import { useTranslations } from "next-intl";
import { HorizontalContainer } from "@/components/layout/containers/HorizontalContainer";
import { VerticalContainer } from "@/components/layout/containers/VerticalContainer";
import { GridContainer } from "@/components/layout/containers/GridContainer";
import { Button } from "@/components/ui/Button";

type Props = {
  suggestions: FilterSuggestion[];
  onApply: (suggestion: FilterSuggestion) => void;
};

/**
 * Grid of available filter suggestions shown in the search dropdown.
 */
export function FilterSuggestionDropdown({ suggestions, onApply }: Props) {
  const t = useTranslations();

  if (suggestions.length === 0) return null;

  return (
    <div className="border-b border-border bg-muted">
      <div className="p-3">
        <VerticalContainer className="mb-2 items-start text-xs text-muted-foreground">
          <HorizontalContainer>
            <Info className="mr-1 h-3 w-3" />
            <span>{t("filters.suggestedFilters")}</span>
          </HorizontalContainer>
        </VerticalContainer>
        <GridContainer cols={2} gap={2} sm={{cols: 3}}>
          {suggestions.map((suggestion) => (
            <Button
              variant="ghost"
              key={`${suggestion.key}:${suggestion.value}`}
              onClick={() => onApply(suggestion)}
              className="flex w-full justify-start items-center space-x-2 rounded-md border border-border px-3 py-2 text-sm hover:bg-accent"
            >
              <span className="text-muted-foreground">{suggestion.icon}</span>
              <span className="font-semibold text-foreground">
                {suggestion.key}:{suggestion.value}
              </span>
            </Button>
          ))}
        </GridContainer>
      </div>
    </div>
  );
}
